<template>
    <section class="bg-light py-10" id="abrir-empresa">
        <div class="container z-1">
            <div class="row justify-content-center">
                <div class="col-xl-10 col-lg-12 col-md-12 text-center">
                    <h2 class="mb-3">
                        Abrir sua empresa com a
                        {{ app.nome }}
                        é fácil e rápido
                    </h2>
                    <p class="lead text-gray-500 mb-10">
                        Somos especialistas em abertura de empresas com
                        atividades de prestação de serviços e nosso passo a
                        passo foi feito para poupar tempo e burocracia dos
                        nossos clientes.
                    </p>
                </div>
            </div>
            <div class="card mb-5" data-aos="fade-right">
                <div class="row no-gutters">
                    <div class="col-md-6">
                        <center>
                            <img
                                class="img-fluid my-4"
                                src="/layouts/site/contabilidade/assets/img/drawkit/color/ilustração-cadastro.svg"
                                alt="..."
                                width="60%"
                                height=""
                            />
                        </center>
                    </div>
                    <div class="col-md-6">
                        <div
                            class="card-body d-flex justify-content-center h-100 flex-column"
                        >
                            <h3
                                class="card-title font-weight-bold text-uppercase mb-2"
                            >
                                CADASTRE-SE
                            </h3>
                            <p class="card-text font-weight-light mb-4">
                                Preencha o formulário de cadastro para que um de
                                nossos especialistas entre em contato com você.
                            </p>
                            <center>
                                <a
                                    class="btn btn-outline-dark btn-marketing rounded-pill"
                                    href="#contato"
                                >
                                    Quero saber
                                    <i class="fas fa-plus fa-fw"></i>
                                </a>
                            </center>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-5" data-aos="fade-left">
                <div class="row no-gutters">
                    <div class="col-md-6 order-1 order-md-0">
                        <div
                            class="card-body d-flex justify-content-center h-100 flex-column"
                        >
                            <h3
                                class="card-title font-weight-bold text-uppercase mb-2"
                            >
                                CONVERSE COM NOSSOS ESPECIALISTAS
                            </h3>
                            <p class="card-text font-weight-light mb-4">
                                Nossos especialistas irão identificar,
                                juntamente com você, o melhor plano de
                                consultoria indicador para atender à sua
                                empresa.
                            </p>
                            <center>
                                <a
                                    class="btn btn-outline-dark btn-marketing rounded-pill"
                                    href="#contato"
                                >
                                    Solicitar contato
                                    <i class="fas fa-arrow-right fa-fw"></i>
                                </a>
                            </center>
                        </div>
                    </div>
                    <div class="col-md-6 order-0 order-md-1">
                        <center>
                            <img
                                class="img-fluid my-4"
                                src="/layouts/site/contabilidade/assets/img/drawkit/color/ilustração-especialistas.svg"
                                alt="..."
                                width="60%"
                                height=""
                            />
                        </center>
                    </div>
                </div>
            </div>
            <div class="card mb-5" data-aos="fade-right">
                <div class="row no-gutters">
                    <div class="col-md-6">
                        <center>
                            <img
                                class="img-fluid my-4"
                                src="/layouts/site/contabilidade/assets/img/drawkit/color/ilustração-escolha.svg"
                                alt="..."
                                width="60%"
                                height=""
                            />
                        </center>
                    </div>
                    <div class="col-md-6">
                        <div
                            class="card-body d-flex align-items-center justify-content-center h-100 flex-column"
                        >
                            <h3
                                class="card-title font-weight-bold text-uppercase mb-2"
                            >
                                ESCOLHA DO MODELO IDEAL DE CONSULTORIA
                            </h3>
                            <p class="card-text font-weight-light mb-4">
                                Com o Melhor Formato definido, basta enviar a
                                documentação solicitada e aguardar.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-5" data-aos="fade-left">
                <div class="row no-gutters">
                    <div class="col-md-6 order-1 order-md-0">
                        <div
                            class="card-body d-flex align-items-center justify-content-center h-100 flex-column"
                        >
                            <h3
                                class="card-title font-weight-bold text-uppercase mb-2"
                            >
                                Pronto!
                            </h3>
                            <p class="card-text font-weight-light mb-4">
                                Sua empresa sempre em dia com o CNPJ em mãos e
                                100% regular. Você está pronto para emitir Notas
                                Fiscais, faturar e com uma contabilidade
                                completa para te tranquilizar!
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 order-0 order-md-1">
                        <center>
                            <img
                                class="img-fluid my-4"
                                src="/layouts/site/contabilidade/assets/img/drawkit/color/ilustração-pronto.svg"
                                alt="..."
                                width="60%"
                                height=""
                            />
                        </center>
                    </div>
                </div>
            </div>
        </div>
        <div class="svg-border-rounded text-white mt-n15">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 144.54 17.34"
                preserveAspectRatio="none"
                fill="currentColor"
            >
                <path
                    d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0"
                ></path>
            </svg>
        </div>
    </section>
</template>
<script>
export default {
    props: ['app']
}
</script>
